
function Stages3() {
	return ( 
		<div>
			<div>
				<p>
					Nach und nach fällt die Rinde des Baumes ab.
				</p>
			</div>
		</div>
	 );
}

export default Stages3;